import type { EmployerSiteNames } from '../siteConfig';
import logWarn from './logWarn';

const UNIFIED_MANAGE_SITE_CONTENT_TBD = 'UNIFIED_MANAGE_SITE_CONTENT_TBD';

export const logUnificationTbdWarnings = ({
  site,
  title,
  desc,
  action,
}: {
  site: EmployerSiteNames;
  title: string;
  desc: string;
  action: string;
}) => {
  logWarn(
    `[${UNIFIED_MANAGE_SITE_CONTENT_TBD}] ${title} | ${desc} - Site:'${site}' | Action taken: ${action}`,
  );
};
